import { stringToBool } from '../helpers/Object';

export const ROLE_ADMINISTRATOR = 'administrator';

/* USER ROLES */
export const ROLE_REGIONAL_SUPERVISOR = 'regional_supervisor';
export const ROLE_AUDITIVE_SUPERVISOR = 'auditive_supervisor';
export const ROLE_OPHTHALMOLOGY_SUPERVISOR = 'ophthalmology_supervisor';
export const ROLE_LAB = 'lab';
export const ROLE_NEONATOLOGIST_BIRTH_CENTRE = 'neonatologist_bc';
export const ROLE_NURSE_BIRTH_CENTRE = 'nurse_bc';
export const ROLE_NEONATOLOGIST_NC = 'neonatologist_nc';
export const ROLE_NURSE_NC = 'nurse_nc';
export const ROLE_GYNECOLOGIST = 'gynecologist';
export const ROLE_OBSTETRICIAN = 'obstetrician';
export const ROLE_BE20 = 'be20';
export const ROLE_AUDITIVE_LEVEL_2 = 'auditive_lv2';
export const ROLE_AUDITIVE_LEVEL_3 = 'auditive_lv3';
export const ROLE_OPHTHALMOLOGY_LEVEL_2 = 'ophthalmology_lv2';
export const ROLE_OPHTHALMOLOGY_LEVEL_3 = 'ophthalmology_lv3';
export const ROLE_CEDAP_MANAGER = 'cedap_manager';
export const ROLE_CEDAP_MANAGER_READ_ONLY = 'cedap_manager_read_only';
export const ROLE_REFERENT_CONGENITAL_MALFORMATIONS = 'referent_congenital_malformations';
export const ROLE_LHC_MANAGER = 'lhc_manager';
export const ROLE_SUPPORT = 'support';
export const ROLE_FACILITY_MANAGER = 'facility_manager';
export const ROLE_PEDIATRIC_CENTRE_RARE_METABOLIC_DISEASES = 'pediatrician_rare_metabolic_diseases';
export const ROLE_PEDIATRIC_CENTRE_HEREDITARY_METABOLIC_DISEASES =
  'pediatrician_hereditary_metabolic_diseases';

export const PEDIATRIC_CENTRE_ROLES = [
  ROLE_PEDIATRIC_CENTRE_RARE_METABOLIC_DISEASES,
  ROLE_PEDIATRIC_CENTRE_HEREDITARY_METABOLIC_DISEASES,
];

export const SPOKE_ROLES = [
  ROLE_NEONATOLOGIST_BIRTH_CENTRE,
  ROLE_NEONATOLOGIST_NC,
  ROLE_NURSE_BIRTH_CENTRE,
  ROLE_NURSE_NC,
];

export const HCP_ROLES = [
  ...SPOKE_ROLES,
  ...(stringToBool(process.env.REACT_APP_ENABLE_AUDITIVE) ? [ROLE_AUDITIVE_LEVEL_2] : []),
  ...(stringToBool(process.env.REACT_APP_ENABLE_CEDAP)
    ? [ROLE_GYNECOLOGIST, ROLE_OBSTETRICIAN]
    : []),
];

export const CEDAP_ROLES = [
  ROLE_NEONATOLOGIST_BIRTH_CENTRE,
  ROLE_NEONATOLOGIST_NC,
  ROLE_GYNECOLOGIST,
  ROLE_OBSTETRICIAN,
  ROLE_CEDAP_MANAGER,
  ROLE_REGIONAL_SUPERVISOR,
  ROLE_REFERENT_CONGENITAL_MALFORMATIONS,
];

export const AUDITIVE_ROLES = [...SPOKE_ROLES, ROLE_AUDITIVE_LEVEL_2];
export const OPHTHALMOLOGY_ROLES = [...SPOKE_ROLES, ROLE_OPHTHALMOLOGY_LEVEL_2];

export const SUPERVISOR_ROLES = [
  ROLE_ADMINISTRATOR,
  ROLE_REGIONAL_SUPERVISOR,
  ROLE_REFERENT_CONGENITAL_MALFORMATIONS,
  ROLE_LAB,
  ROLE_BE20,
  ROLE_SUPPORT,
  ...(stringToBool(process.env.REACT_APP_ENABLE_CEDAP)
    ? [ROLE_CEDAP_MANAGER, ROLE_CEDAP_MANAGER_READ_ONLY]
    : []),
  ...(stringToBool(process.env.REACT_APP_ENABLE_AUDITIVE) ? [ROLE_AUDITIVE_SUPERVISOR] : []),
];

export const NEONATOLOGIST_ROLES = [ROLE_NEONATOLOGIST_BIRTH_CENTRE, ROLE_NEONATOLOGIST_NC];
